import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/discovery/useDiscoveryQueryKeys.ts
var t = e("discovery", {
	listings: (e) => e ? ["listings", e] : ["listings"],
	facets: (e) => e ? [
		"facets",
		e.kind,
		e.city ?? null
	] : ["facets"],
	happeningToday: (e) => e ? [
		"happening-today",
		e.kind ?? null,
		e.city ?? null
	] : ["happening-today"],
	similar: (e) => ["similar", e]
});
//#endregion
export { t as discoveryQueryKeys };
